import type { Language } from "../../../shared/api.ts";

/** Ukraine's time zones, with the older names some browsers still report. */
const UKRAINE_TIME_ZONES = new Set(["Europe/Kyiv", "Europe/Kiev", "Europe/Uzhgorod", "Europe/Zaporozhye", "Europe/Simferopol"]);

/**
 * The language for someone who hasn't chosen one: Ukrainian in Ukraine or in a browser that prefers Ukrainian,
 * otherwise English. The device's time zone tells where they are. It needs no IP database, nothing leaves the browser,
 * and it holds on a VPN.
 *
 * @param timeZone - The device's IANA time zone.
 * @param browserLanguages - The browser's languages, such as `navigator.languages`.
 * @returns The default language.
 */
export function defaultLanguage(timeZone: string | undefined, browserLanguages: readonly string[]): Language {
  const inUkraine = timeZone !== undefined && UKRAINE_TIME_ZONES.has(timeZone);
  return inUkraine || browserLanguages.some((language) => /^uk\b/i.test(language)) ? "uk" : "en";
}

/** {@link defaultLanguage} for this browser. */
export function browserDefaultLanguage(): Language {
  return defaultLanguage(Intl.DateTimeFormat().resolvedOptions().timeZone, navigator.languages);
}
